import { Box, Typography } from '@mui/material';
import React from 'react';
import { TypographyH3Bold } from '../../../features/malnutritionScreening/style';

export const BlueScoreCard = ({
  label,
  score
}: {
  label: string;
  score: number;
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        padding: '0.625rem 0.9375rem',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '0.625rem',
        height: '65px',
        alignSelf: 'stretch',
        backgroundColor: '#5BC2E740',
        color: '#002A3A',
        borderRadius: '0.9375rem',
        margin: '1.25rem 0',
        width: '100%'
      }}
    >
      <TypographyH3Bold>{label}</TypographyH3Bold>
      <Typography
        sx={{
          fontFamily: 'Calibri',
          fontWeight: 700,
          fontSize: '1.875rem'
        }}
      >
        <span
          data-testid="estHeightUlnaTest"
          style={{
            background: '#F2F2F2',
            height: '45px',
            width: '45px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50%'
          }}
        >
          {score}
        </span>
      </Typography>
    </Box>
  );
};
